import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { YOUTUBE_API } from "../utils/Constant";
import VideoCard from "./VideoCard";
import { AdVideoCard } from "./VideoCard";

const VideoContainer = () => {
  const [videos, setVideos] = useState([]);
  useEffect(() => {
    getVideos();
  }, []);

  const getVideos = async () => {
    const data = await fetch(YOUTUBE_API);
    const json = await data.json();
    // console.log(json.items)
    setVideos(json.items);
  };

  return (
    <div className="flex flex-row flex-wrap px-3 m-3">
      {videos[0] && <AdVideoCard info={videos[0]}/>}
      {videos.map((video) => (
        <Link  key={video.id} to={"/watch?v="+video.id}>
          <VideoCard info={video}/>
        </Link>
      ))}
    </div>
  );
};

export default VideoContainer;
